module.exports = __webpack_public_path__ + "img/Teammember-edit-icon.0cb7a92d.svg";